const About = () => {
  return (
    <div id="main" className="h-[calc(100vh-150px)] flex justify-center items-center bg-white dark:bg-black">
      <div className="fof">
        <h1 className="text-5xl inline-block text-black dark:text-white">This is About Page</h1>
      </div>
    </div>
  );
};

export default About;
